import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BookOpen, Home, Trophy, User, Zap } from 'lucide-react';
import { theme } from '@shared/styles/theme';
import { styles } from './MobileBottomNav.styles';

/**
 * Mobile bottom tab navigation with clean design.
 */
export const MobileBottomNav: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation('common');

  const navItems = [
    { label: t('navigation.dashboard'), path: '/dashboard', Icon: Home },
    { label: t('navigation.topics'), path: '/topics', Icon: BookOpen },
    { label: t('navigation.dailyChallenge'), path: '/daily-challenge', Icon: Zap },
    { label: t('navigation.badges'), path: '/badges', Icon: Trophy },
    { label: t('navigation.profile'), path: '/profile', Icon: User },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav style={styles.bottomNav}>
      {navItems.map((item) => {
        const active = isActive(item.path);
        return (
          <Link
            key={item.path}
            to={item.path}
            style={{
              ...styles.navItem,
              ...(active ? styles.navItemActive : styles.navItemInactive),
            }}
          >
            <div
              style={{
                ...styles.iconWrapper,
                ...(active ? styles.iconWrapperActive : {}),
              }}
            >
              <item.Icon
                size={26}
                color={active ? theme.colors.text.white : theme.colors.text.gray800}
                strokeWidth={active ? 2.2 : 1.8}
                aria-hidden="true"
              />
            </div>
            <span
              style={{
                ...styles.label,
                color: active ? theme.colors.nav.activeBackground : theme.colors.text.gray800,
                fontWeight: active ? '600' : '500',
              }}
            >
              {item.label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
};
